export const carouselTypes = {
  PORTFOLIO: 1,
  DEPARTMENT: 2,
};
